module.exports = __webpack_public_path__ + "static/img/env24.99afb5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env24.png
// module id = 114
// module chunks = 4